import React, { useEffect, useState } from "react";
import xIcon from "../../../../assets/design-revamp-company/add-edit/chip-delete-icon.svg";
import addIcon from "../../../../assets/design-revamp-company/add-edit/plusIcon.svg";

const BuildingTypeInput = ({
  value,
  onChange,
  t,
  isEditing,
  types,
  setTypes,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (value && Array.isArray(value)) {
      setTypes((prevTypes) =>
        prevTypes.map((type) => ({
          ...type,
          checked: value.some((v) => v.name_en === type.name_en),
          space_percentage:
            value.find((v) => v.name_en === type.name_en)?.space_percentage ||
            null,
        }))
      );
    }
  }, [value, setTypes]);

  const handleTypeChangeNew = (name_en) => {
    if (!isEditing) return;
    const newTypes = types.map((type) =>
      type.name_en === name_en ? { ...type, checked: !type.checked } : type
    );
    setTypes(newTypes);
    onChange(newTypes.filter((type) => type.checked));
    setShowDropdown(false);
  };

  const handleTypeChangeUpdate = (oldNameEn, newNameEn) => {
    if (!isEditing) return;
    const newTypes = types.map((type) => {
      if (type.name_en === oldNameEn) {
        // Uncheck the old type
        return { ...type, checked: false, space_percentage: null };
      } else if (type.name_en === newNameEn) {
        // Check the new type and transfer the space percentage
        const oldType = types.find((t) => t.name_en === oldNameEn);
        return {
          ...type,
          checked: true,
          space_percentage: oldType.space_percentage,
        };
      }
      // Leave other types unchanged
      return type;
    });
    setTypes(newTypes);
    onChange(newTypes.filter((type) => type.checked));
    setShowDropdown(false);
  };

  const handleSpaceChange = (name_en, value) => {
    if (!isEditing) return;
    const newTypes = types.map((type) =>
      type.name_en === name_en ? { ...type, space_percentage: value } : type
    );
    setTypes(newTypes);
    onChange(newTypes.filter((type) => type.checked));
  };

  const renderEditMode = () => (
    <div className="type-inputs">
      {types
        .filter((type) => type.checked)
        .map((type) => (
          <div key={type.name_en} className="type-input">
            <div className="type-chip">
              <button
                className="remove-type"
                onClick={() => handleTypeChangeUpdate(type.name_en)}
                disabled={!isEditing}
              >
                <img src={xIcon} alt="Remove" width={14} height={14} />
              </button>
              <select
                value={type.name_en}
                onChange={(e) =>
                  handleTypeChangeUpdate(type.name_en, e.target.value)
                }
                disabled={!isEditing}
              >
                {types.map((option) => (
                  <option key={option.name_en} value={option.name_en}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ position: "relative", display: "inline-block" }}>
              <input
                type="text"
                value={type.space_percentage || ""}
                onChange={(e) =>
                  handleSpaceChange(type.name_en, e.target.value)
                }
                placeholder="0"
                disabled={!isEditing}
                style={{ paddingRight: "30px" }}
              />
              <span
                style={{
                  position: "absolute",
                  right: "5px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "white",
                  fontSize: "12px",
                }}
              >
                m²
              </span>
            </div>
          </div>
        ))}
      {showDropdown ? (
        <select
          onChange={(e) => {
            handleTypeChangeNew(e.target.value);
            setShowDropdown(false);
          }}
          value=""
          disabled={!isEditing}
        >
          <option value="" disabled>
            Select a type
          </option>
          {types
            .filter((type) => !type.checked)
            .map((option) => (
              <option key={option.name_en} value={option.name_en}>
                {option.name}
              </option>
            ))}
        </select>
      ) : (
        <div className="add-bg-btn">
          <button
            className="add-type"
            onClick={() => setShowDropdown(true)}
            disabled={!isEditing}
          >
            <img src={addIcon} alt="" width={21} height={21} />
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div className="building-type-input">
      <label>{t("TYPE")}</label>
      {renderEditMode()}
    </div>
  );
};

export default BuildingTypeInput;
